import {StepperIcon} from "./StepperIcon";
export default StepperIcon;